module.exports = __webpack_public_path__ + "static/new-planning-big-b84cce5593ccc360a1d58367973488dc.png";